import { Dispatch } from 'redux';

import { ISsnDetailsResponse } from '../../modules/members/common/types';
import API from '../../services/API';
import { setError, startSpinner, stopSpinner } from '../common/actionCreators';
import { ADD_MEMBER_ACTION_TYPES } from './../../constants/actionTypes/addMemborActionTypes';

const actions = { setError, startSpinner, stopSpinner };

export const postMember =
    (...args) =>
    async (dispatch: Dispatch) => {
        const [url, payload] = args;
        try {
            const params = [url, payload, 'POST', true, undefined, 'application/json;charset=utf-8'];
            const data = await API.postData(params, dispatch, actions);
            if (data) {
                return Promise.resolve(data);
            } else {
                throw new Error(data.message || 'Failed to post member data');
            }
        } catch (error) {
            dispatch(stopSpinner());
            return Promise.reject(error);
        }
    };

export const fetchSsndetails = url => async dispatch => {
    const data: ISsnDetailsResponse = await API.getData(url, dispatch, actions, true);
    if (data) {
        dispatch(setSsndetails({ ...data }));
    } else {
        dispatch(stopSpinner());
        console.error('Cannot get add member config', url);
    }
};

export const setSsndetails = tabKey => ({
    type: ADD_MEMBER_ACTION_TYPES.GET_SSN_DETAILS,
    payload: tabKey,
});
